const galleryItem = (id, number, orientation) => ({
  id,
  title: `Learner success story ${String(number).padStart(2, "0")}`,
  description: "Real S-UK learner pass moment",
  videoSrc: `/media/video-gallery/${id}.mp4`,
  posterSrc: `/video-thumbnails/${id}.webp`,
  orientation,
});

export const VIDEO_GALLERY = [
  galleryItem("client-video-32", 1, "portrait"),
  galleryItem("client-video-01", 2, "portrait"),
  galleryItem("client-video-02", 3, "portrait"),
  galleryItem("client-video-03", 4, "portrait"),
  galleryItem("client-video-04", 5, "portrait"),
  galleryItem("client-video-05", 6, "portrait"),
  galleryItem("client-video-06", 7, "portrait"),
  galleryItem("client-video-07", 8, "square"),
  galleryItem("client-video-08", 9, "square"),
  galleryItem("client-video-10", 10, "portrait"),
  galleryItem("client-video-11", 11, "portrait"),
  galleryItem("client-video-12", 12, "square"),
  galleryItem("client-video-13", 13, "square"),
  galleryItem("client-video-14", 14, "square"),
  galleryItem("client-video-15", 15, "square"),
  galleryItem("client-video-16", 16, "square"),
  galleryItem("client-video-17", 17, "square"),
  galleryItem("client-video-18", 18, "square"),
  galleryItem("client-video-19", 19, "square"),
  galleryItem("client-video-20", 20, "square"),
  galleryItem("client-video-21", 21, "portrait"),
  galleryItem("client-video-22", 22, "portrait"),
  galleryItem("client-video-23", 23, "square"),
  galleryItem("client-video-24", 24, "portrait"),
  galleryItem("client-video-25", 25, "portrait"),
  galleryItem("client-video-26", 26, "portrait"),
  galleryItem("client-video-27", 27, "portrait"),
  galleryItem("client-video-28", 28, "portrait"),
  galleryItem("client-video-29", 29, "portrait"),
  galleryItem("client-video-30", 30, "portrait"),
  galleryItem("client-video-31", 31, "portrait"),
];
